import { render, staticRenderFns } from "./SMSAdsAddFailedContact.vue?vue&type=template&id=a188baca"
import script from "./SMSAdsAddFailedContact.vue?vue&type=script&lang=js"
export * from "./SMSAdsAddFailedContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports